import * as types from '../types';
import { IDataTranscriberValidationDraft } from '../common/defaults';

export interface IDataTranscriberValidationState {
  DataTranscriberValidationDrafts: IDataTranscriberValidationDraft[];
  DataTranscriberValidationFormIoFormId: string;
}

const initialState: IDataTranscriberValidationState = {
  DataTranscriberValidationDrafts: [],
  DataTranscriberValidationFormIoFormId: '',
};

export default (
  state: IDataTranscriberValidationState = initialState,
  action: any
) => {
  let _state = { ...state };
  switch (action.type) {
    case types.LOAD_ALL_TYPES_INTO_STORE:
      return {
        ...state,
        DataTranscriberValidationDrafts: [
          ...state.DataTranscriberValidationDrafts,
          ...action.value,
        ],
      };
    case types.GET_FORM_IO_FORM_ID:
      return {
        ...state,
        DataTranscriberValidationFormIoFormId: action.value,
      };
    default:
      return state;
  }
};
